<div class="row" >
  <div class="col-md-12">
    <nb-card class="inline-form-card">
      <nb-card-header>{{'Alterar Senha' | translate}}</nb-card-header>
      <nb-card-body>

        <form class="form" [formGroup]="form" novalidate (keydown.enter)="$event.preventDefault()">

          <div *ngIf="usuario.AtualizarDados">
            <div class="row form-group">
              <div class="col-sm-4">
                <app-input>
                  <label>{{'Nome' | translate}}</label>
                  <input autocomplete="off" type="text" class="form-control input-sm" [(ngModel)]="usuario.Nome" formControlName="Nome" name="inputNome">
                </app-input>
              </div>
              <div class="col-sm-4">
                <app-input>
                  <label>{{'Sobrenome' | translate}}</label>
                  <input autocomplete="off" type="text" class="form-control input-sm" [(ngModel)]="usuario.Sobrenome" formControlName="Sobrenome" name="inputSobrenome">
                </app-input>
              </div>
              <div class="col-sm-4">
                <app-input>
                  <label>{{'Email' | translate}}</label>
                  <input autocomplete="off" type="text" class="form-control input-sm" [(ngModel)]="usuario.Email" formControlName="Email" name="inputEmail">
                </app-input>
              </div>
              <div class="col-sm-4" *ngIf="!usuario.Agencia || usuario.Agencia.Idioma == 'pt'">
                <app-input modelo="000.000.000-00">
                  <label>{{'CPF' | translate}}</label>
                  <input autocomplete="off" [textMask]="{mask: MASKS.cpf.textMask}" type="text" class="form-control input-sm"
                    [(ngModel)]="usuario.Cpf" formControlName="CPF" name="inputCNPJ">
                </app-input>
              </div>
              <div class="col-sm-4" *ngIf="usuario.Agencia && usuario.Agencia.Idioma != 'pt'">
                <app-input>
                  <label>{{'CPF' | translate}}</label>
                  <input autocomplete="off" type="text" class="form-control input-sm"
                    [(ngModel)]="usuario.Cpf" formControlName="CPF" name="inputCNPJ">
                </app-input>
              </div>
              <div class="col-md-3">
                    <app-input>
                        <label>{{'RG' | translate}}</label>
                        <input autocomplete="off" type="text" class="form-control input-sm input-block " [(ngModel)]="usuario.Rg"
                            formControlName="Rg" name="inputRg">
                    </app-input>
                </div>
            </div>

            <div class="row form-group">
              <div class="col-sm-4">
                <app-input>
                  {{'Telefone' | translate}}
                  <input autocomplete="off" [textMask]="{mask: MASKS.telefone.textMaskFunction}" type="text" class="form-control input-sm" [(ngModel)]="usuario.Telefone" formControlName="Telefone" name="inputTelefone">
                </app-input>
              </div>
              <div class="col-sm-4">
                <label class="label">{{'Data de Nascimento' | translate}}</label>
                <input class="form-control input-sm" placeholder="dd/mm/aaaa" [nbDatepicker]="ngmodel2" [(ngModel)]="usuario.DataNascimento" formControlName="DataNascimento" name="inputDataNascimento">
                <nb-datepicker format="DD/MM/YYYY" #ngmodel2></nb-datepicker>
              </div>
              <div class="col-sm-4">
                <label class="label">{{'Cidade' | translate}}</label>
                <typeahead [tap]="false" name="cidadeAutoComplete" [lista]="data" [searchText]="usuario.Cidade.Nome" (searchFunction)="onChangeCidade($event)" (selectItem)="selecionaCidade($event)">
                  <input autocomplete="off" class="form-control input-sm" formControlName="CidadeId" [(ngModel)]="usuario.Cidade.Nome" name="cidade" (ngModelChange)="onChangeCidade($event)"/>
                </typeahead>
              </div>
            </div>
          </div>

          <div class="form-group row" >
            <div class="col-sm-4">
              <app-input>
                <label>{{'Senha Atual' | translate}}</label>
                <input [disabled]="loadingAlterarSenha" formControlName="SenhaAtual" type="password" class="form-control full-width" [(ngModel)]="senhaAtual" name="senhaAtual">
              </app-input>
            </div>

            <div class="col-sm-4">
              <app-input>
                <label>{{'Nova Senha' | translate}}</label>
                <input [disabled]="loadingAlterarSenha" formControlName="Senha" type="password" class="form-control full-width" [(ngModel)]="senha" name="senha">
              </app-input>
            </div>

            <div class="col-sm-4">
              <app-input>
                <label>{{'Confirme' | translate }}</label>
                <input [disabled]="loadingAlterarSenha" formControlName="Resenha" type="password" class="form-control full-width" [(ngModel)]="resenha" name="resenha">
              </app-input>
            </div>
          </div>

          <div class="row form-group">
            <div class="col-sm-12" *ngIf="usuario.flAssinaContrato || usuario.AgenteAdmin">
              <nb-accordion class="card-sem-sombra">
                <nb-accordion-item expanded="true">
                  <nb-accordion-item-header>
                    <h4 class="fonte-cabecalho-card">{{'Assinatura digitalizada' | translate}}</h4>
                  </nb-accordion-item-header>
                  <nb-accordion-item-body>
                    <div class="row">
                      <div class="col-sm-6">
                        <div id="signature-pad" class="signature-pad">
                          <div class="signature-pad--body">
                            <label><strong>{{'Escrever' | translate }}</strong></label>
                            <p style="border-width: 1px;border-style: solid;border-color: #181818;">
                              <canvas #sPad width="555" height="200"></canvas>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6" *ngIf="usuario.AssinaturaDigitalizada != null">
                        <label><strong>{{ "Assinatura" | translate }}</strong></label>
                        <p style="border-width: 1px;border-style: solid;border-color: #181818;">
                          <img src="{{Api}}{{usuario.AssinaturaDigitalizada}}" />
                        </p>
                      </div>
                    </div>
                    <!-- <div class="row"></div> -->
                    <div class="row">
                      <div class="col-sm-6" style="margin-top: 4px;">
                        <button class="btn btn-success" (click)="savePNG()" type="submit">{{'Registrar Assinatura' | translate}}</button>
                        <button class="btn btn-success" (click)="limpar()" type="submit" style="margin-left: 1%;">{{'Limpar' | translate}}</button>
                      </div>
                    </div>
                  </nb-accordion-item-body>
                </nb-accordion-item>
              </nb-accordion>
            </div>
          </div>

          <div class="form-group row" >
            <div class="col-sm-6">
              <button [disabled]="!form.valid || this.alterada" [hidden]="loadingAlterarSenha || loadingAlterarDados" type="submit" class="btn btn-primary  btn-block" (click)="alterarSenha()">{{'Alterar' | translate}}</button>
            </div>
            <div class="col-sm-6">
              <button [disabled]="alteracaoObrigatoria" type="button" class="btn btn-primary btn-block" (click)="fecharModal()">{{'Sair' | translate}}</button>

            </div>
            <span *ngIf="alteracaoObrigatoria" class="font-weight-light font-italic">{{'Alteração de senha obrigatória' | translate}}</span>

          </div>

          <img width="50px" src="assets/img/loading1.gif" [hidden]="!loadingAlterarSenha"/>
        </form>


        <div [hidden]="!sucessoAlterarSenha" class="alert alert-success">{{'Senha Alterada com sucesso' | translate}}!</div>
        <div class="alert alert-danger" *ngIf="erroAlterarSenha">{{erroAlterarSenha | translate}}</div>
        <div [hidden]="!sucessoAlterarDados" class="alert alert-success">{{'Dados Alterados com sucesso' | translate}}!</div>
        <div class="alert alert-danger" *ngIf="erroAlterarDados">{{erroAlterarDados | translate }}</div>
      </nb-card-body>
    </nb-card>
  </div>
</div>
